import { StarRating } from './StarRating';

interface Props {
    id: string;
    url: string;
    image: string;
    heading: string;
    location: string;
    price?: string;
    rating?: number;
}

export const Offer = ({ id, url, image, heading, location, price, rating }: Props) => (
    <article className="seo-offer-card p-8 hover:s-bg-hover" key={`${id}SeoOffer`}>
        <a className="grid grid-cols-5 items-center s-text hover:no-underline" href={url}>
            <div className="col-span-2 seo-offer-image">
                <img src={image} className="rounded-8" alt={heading} data-testid="resultImage" />
            </div>
            <div className="col-span-3">
                {rating ? <StarRating id={id} rating={rating} emptyStars className="mb-8" /> : null}
                <h3 className="text-16 font-normal">{heading}</h3>
                <p className="text-14">{location}</p>
                <p className="font-bold">{price}</p>
            </div>
        </a>
    </article>
);
